export default __webpack_public_path__ + "e246ceb.png";